import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Dashboard } from './pages/Dashboard';
import { FlowsPage } from './pages/FlowsPage';
export function App() {
  const [activeTab, setActiveTab] = useState<'dashboard' | 'fleet' | 'deliveries'>('dashboard');
  return <div className="h-screen w-screen bg-slate-950 flex flex-col overflow-hidden font-sans" data-id="element-0">
      {/* Global Navigation Bar */}
      <div className="h-12 bg-slate-950 border-b border-slate-800 flex items-center justify-between px-6 shrink-0" data-id="element-1">
        {/* Logo */}
        <div className="flex items-center gap-2.5" data-id="element-2">
          <div className="w-8 h-8 rounded-lg bg-brand-blue/20 border border-brand-blue/30 flex items-center justify-center" data-id="element-3">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4">
              <path d="M12 2L4 7V17L12 22L20 17V7L12 2Z" stroke="#3b82f6" strokeWidth="2" strokeLinejoin="round" data-id="element-5" />
              <path d="M12 8V16" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" data-id="element-6" />
              <path d="M8 10L12 8L16 10" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-7" />
            </svg>
          </div>
          <span className="text-sm font-semibold text-slate-100 tracking-tight" data-id="element-8">
            FleetKeep
          </span>
        </div>
        <div className="flex items-center" data-id="element-9">
          {(['dashboard', 'fleet', 'deliveries'] as const).map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`relative px-4 pb-3.5 pt-3 text-sm font-medium transition-colors ${activeTab === tab ? 'text-slate-100' : 'text-slate-500 hover:text-slate-300'}`} data-id="element-10">
              {tab === 'dashboard' ? 'Dashboard' : tab === 'fleet' ? 'Fleet' : 'Deliveries'}
              {activeTab === tab && <motion.div layoutId="globalNavIndicator" className="absolute bottom-0 left-0 right-0 h-[2px] bg-brand-blue rounded-full" transition={{
            type: 'spring',
            damping: 30,
            stiffness: 400
          }} data-id="element-11" />}
            </button>)}
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 w-full h-full relative overflow-hidden" data-id="element-12">
        {activeTab === 'dashboard' ? <Dashboard data-id="element-13" /> : <div className="flex items-center justify-center h-full text-slate-500" data-id="element-14">
            {activeTab === 'fleet' ? 'Fleet View Placeholder' : 'Deliveries View Placeholder'}
          </div>}
      </div>
    </div>;
}